import { axios } from '@Root/API'

export const getContactUpdateById = id => {
  return axios.get(`cognito-contact-updates/${id}`)
}
